import BaseVueComponent from "common/BaseVueComponent"
import { Component } from "vue-property-decorator"

@Component
export default class FloatingActionButtonBase extends BaseVueComponent {}
